import {Col, Space, Typography} from "antd";
import routes from "../../../engine/routes";
import { PrestationAction } from "../PrestationAction/PrestationAction";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import LogHistory from "../LogHistory";
import { useSelector } from "react-redux";
import { roles } from "../../../utils/constants";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";

export const PrestationHeader = ({ title }) => {
  const { loading, loadingAppel, loadingAnswer, ready } = useSelector(
    state => state.prestation,
  );

  return (
    <Col span={24}>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory
          updateEndPoint={[loading, loadingAppel, loadingAnswer, ready]}
        />
      </ActionRoleSpecific>
      <Space
        style={{
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          <RenderTitle title={title} />
        </Typography.Title>
        <PrestationAction />
      </Space>
    </Col>
  );
};
